import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createInvoice } from '../api/invoicesApi';

// SignalR's UpdateInvoiceTable handles cache invalidation — useInvoicesByJob
// listens and refetches, so no optimistic write here.
export default function useCreateInvoice() {
    return useMutation({
        mutationFn: createInvoice,
        onSuccess: () => toast.success('Invoice created'),
        onError: (err) => toast.error(err?.message ?? 'Failed to create invoice'),
    });
}
